import { config } from 'env_def';
import { apis } from '../../../config';
import { api } from '../../../api/api';
export const tableDefs = {};
export class HttpCacheNewImpl {
    constructor() {
        this.dbName = 'caches';
        this.inited = false;
        this.table = { tableName: 'http', dbName: this.dbName };
        this.defaultExpiredTime = 14 * 24 * 3600 * 1000;
        this.db = api.requireLogicalApi(apis.dbInterfaceApiImpl);
        this.host = config('host');
    }
    clear() { }
    close() {
        this.inited = false;
    }
    deleteItem(rqKey) {
        if (!this.inited) {
            return Promise.reject('not inited');
        }
        return this.db.deleteById(this.table, rqKey);
    }
    get(content) {
        console.log('[http-cache] get http cache for ', content);
        if (!this.inited) {
            return Promise.reject('not inited');
        }
        if (content && content.rqKey) {
            return this.db.getById(this.table, content.rqKey);
        }
        return Promise.resolve(undefined);
    }
    init() {
        this.db.initDb(this.dbName);
        this.inited = true;
    }
    put(req, res) {
        var _a;
        console.log('[http-cache] put http request cache:', req, res);
        if (!this.inited) {
            return Promise.reject('not inited');
        }
        if (req.expiredPeriod && req.expiredPeriod < 0) {
            return Promise.resolve();
        }
        const time = new Date().getTime();
        const content = JSON.stringify(res);
        const data = {
            id: req.rqKey || '_',
            urlPath: (_a = req.url) === null || _a === void 0 ? void 0 : _a.replace(this.host, ''),
            urlKeyParam: '',
            urlSubParam: '',
            content,
            contentSize: content.length,
            createTime: time,
            expiredTime: time + (req.expiredPeriod || this.defaultExpiredTime),
        };
        return this.db.put(this.table, data);
    }
}
export const httpCacheImpl = new HttpCacheNewImpl();
